<template>
  <span class="user-profile-setting-gallery-item" style="height:auto;width:auto">
    {{ awesome}}
    <Spin v-if="isUploading" fix></Spin>
    <span @click="showModal()" v-if="!isNew && !activity.isDeleted">
      <Avatar shape="square"  :src="imageDisplay" v-if="activity && activity.cover_photo" style="width:60px;height:60px"></Avatar>
    </span>
    <Upload v-if="activity && isNew"
      :show-upload-list="false"
      ref="upload"
      :before-upload="handleBefore"
      :on-error="handleError"
      :on-success="handleSuccess"
      :format="['jpg','jpeg','png']"
      :max-size="6144"
      :action="uploadUrl"
      name="photo[]">
        <Avatar shape="square" style="width:60px;height:60px;line-height: 17px;font-size:.8rem">
          <Icon style="font-size:20px;margin-top:10px" type="plus-circled"></Icon>
          <span style="display:block">Upload</span>
        </Avatar>
    </Upload>

    <Modal
        v-model="modal1"
        :transfer="true"
        title="View">
        <div style="text-align:center">
          <Avatar shape="square" :src="imageDisplay"
            v-if="activity && activity.cover_photo"
            style="width:auto;height:100%">
          </Avatar>
          <div class="btn-options">
            <Upload v-if="activity"
              :show-upload-list="false"
              ref="upload"
              :before-upload="handleBefore"
              :on-error="handleError"
              :on-success="handleSuccess"
              :format="['jpg','jpeg','png']"
              :max-size="6144"
              :action="uploadUrl"
              name="photo[]">
              <i-button>Change</i-button>
            </Upload>
            &nbsp;
            <i-button type="primary" v-if="false" @click="setAsAvatar()">Set as Avatar</i-button>&nbsp;
            <i-button @click="onRemove()" type="error">Delete</i-button>
          </div>
        </div>
        <div slot="footer"></div>
    </Modal>
  </span>
</template>

<script>
import _ from 'lodash'
import Utils from '@/utils.js'
import Vue from 'vue'

export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_TEMP,
      isUploading: false,
      modal1: false,
      activity: {...this.item},
      awesome: ''
    }
  },
  props: {
    item: {
      type: Object
    },
    isNew: {
      type: Boolean
    }
  },
  computed: {
    gallery: {
      get() {
        return this.$parent.$parent.gallery.activity
      }
    },
    imageDisplay: {
      get() {
        if(this.activity.cover_photo.length > 0 && 'image' in this.activity.cover_photo[0] )
          return this.baseUrl + this.activity.cover_photo[0].image
        else
          return Utils.getDisplayImage('activity', this.activity, 'large')
      }
    },
    uploadUrl() {
      return process.env.VUE_APP_API  + 'uploadphoto';
    }
  },
  methods: {
    setAsAvatar() {
      this.$store.dispatch('gallery/setGalleryAvatar', {act: this.activity}).then(res => {
        BroadcastEvent.$emit('ONSETAVATARIMAGECHANGE')
        BroadcastEvent.$emit('ONNEWIMAGECHANGEGALLERY', res.image)
        this.modal1 = false;
      })
    },
    showModal() {
      this.modal1 = !this.modal1
    },
    confirmDelete() {
      this.item['isDeleted'] = 1;
      this.showModal();
      this.$parent.$parent.gallery.activity.total -= 1;
      BroadcastEvent.$emit('ONGALLLERYFIELDCHANGE')
    },
    onRemove() {
      this.$Message({
        closable: true,
        title: { content:'Delete Post' },
        icon: 'ios-trash',
        message: { content: 'Are you sure you want to delete this post?' },
        buttons: [
          { label: 'Yes', type: 'error', hideAfter:true, action: ()=> this.confirmDelete() },
          { label: 'Cancel', type: 'primary', hideAfter:true, action: ()=> {} }
        ]
      });
    },
    setAvatar (n) {
       let newActivity = {...this.activity}

      if( this.isNew ) {
        newActivity.activity_name = this.$parent.$parent.profile.display_name;
        newActivity.title = this.$parent.$parent.profile.display_name;
        newActivity.data_type = 'content';
        newActivity.type = 'gallery';
      }

      newActivity['cover_photo'] = [{
        "day": 0,
        "image": n
      }]

      if( 'id' in this.activity && this.activity.id) {
        // TODO UPDATE
        Vue.nextTick(() => {
          this.item['status'] = newActivity['status'] = 'updated';
          this.showModal();
          this.item['cover_photo'] = [{
            "day": 0,
            "large": n,
            "medium": n,
            "original": n,
            "small": n,
            "image": n
          }];
          this.activity = this.item
          this.awesome = null
          BroadcastEvent.$emit('ONGALLLERYFIELDCHANGE')
          this.$store.commit('gallery/setGalleryItemData', newActivity);

        })
      } else {
        // TODO CREATE
        BroadcastEvent.$emit('ONGALLLERYFIELDCHANGE')
        newActivity.guid = Utils.uuidGenerator();

        this.$store.commit('gallery/addNewActivity', newActivity);
      }
    },
    handleSuccess (res, file) {
      this.isUploading = false
      this.setAvatar(file.response.uploaded[0])
    },
    handleBefore() {
      this.isUploading = true
    },
    handleError() {
      this.isUploading = false
    }
  },
  mounted() {

  }
}
</script>

<style>
  .btn-options > .ivu-upload {
    display: inline-block !important;
  }
  .user-profile-setting-gallery-item .ivu-avatar > * {
    line-height: 17px;
  }
</style>
